import { PATH } from '@/app/routes';
import { useActualiseApp } from '@/features';
import { CatalogDataProvider } from '@/app/context';
import { cn, isTelegramWebApp } from '@/shared/lib';
import { MinimalisticHeader } from '@/widgets/headers';
import { BrandTgLogo, ErrorBoundary } from '@/shared/components';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';
import { DeliveryAddressModal, AddressViewModal } from '@/widgets';
import { useTelegramBackButton, useAndroidNavBar, useTgCloseModal } from '@/shared/hooks';

const HIDDEN_HEADER_ROUTES = [PATH.documents, PATH.documentView];

export const BaseLayout = () => {
  useTgCloseModal();
  useAndroidNavBar();
  useTelegramBackButton();
  const data = useActualiseApp();
  const isTgWebApp = isTelegramWebApp();

  const { pathname } = useLocation();
  const minimalistic = useAppSelector(selectIsMinimalistic);
  const showMinimalisticHeader = minimalistic && !HIDDEN_HEADER_ROUTES.some((route) => matchPath(route, pathname));

  return (
    <div className='h-full-screen flex flex-col mt-full-screen-header'>
      <ErrorBoundary>
        <BrandTgLogo />
        <main className={cn('flex-1 max-h-full', (isTgWebApp || !minimalistic) && 'pb-safe')}>
          <CatalogDataProvider data={data}>
            {showMinimalisticHeader && <MinimalisticHeader />}
            <Outlet />
          </CatalogDataProvider>
        </main>
        <DeliveryAddressModal />
        <AddressViewModal />
      </ErrorBoundary>
    </div>
  );
};
